import { AxiosRequestConfig, AxiosResponse } from 'axios';
import httpClient from './httpClient';

export const GET = <T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    options?: AxiosRequestConfig
) => {
    return httpClient.request<T, R, D>({ method: 'GET', url, ...options });
};
